// import { initializeFaro } from '@grafana/faro-web-sdk';

export default defineNuxtPlugin(() => {
	// const faro = initializeFaro({
	// 	url: 'https://agent.myapp/collect',
	// 	apiKey: 'secret',
	// 	app: {
	// 		name: 'frontend',
	// 		version: '1.0.0'
	// 	}
	// });

	return {
		provide: {}
	};
});
